<template>
    <div class="relative p-4 rounded-md w-80"
        :class="successful ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
        <p>{{ message }}</p>
        <!-- Barre de progression -->
        <div class="absolute bottom-0 left-0 h-1 w-full bg-gray-300 rounded-b">
            <div class="h-full bg-current rounded-b" :style="{ width: progress + '%' }"></div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
    message: { type: String, required: true },
    successful: { type: Boolean, default: false },
    duration: { type: Number, default: 5000 } // durée en ms
})


const emit = defineEmits(['close'])

const progress = ref(0)

onMounted(() => {
    const interval = 50 // update toutes les 50ms
    const step = interval / props.duration * 100
    const timer = setInterval(() => {
        progress.value += step
        if (progress.value >= 100) {
            clearInterval(timer)
            emit('close')
        }
    }, interval)
})
</script>

<style scoped>
/* Barre de progression colorée selon le message */
.bg-green-100 .bg-current {
    background-color: #22c55e;
    /* vert */
}

.bg-red-100 .bg-current {
    background-color: #ef4444;
    /* rouge */
}
</style>
